import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Layout } from "./components";
import { useDashboardRoutes } from "./modules/Dashboard/router";
import { useCustomerRoutes } from "./modules/Customers/router";
import { useUsersRoutes } from "./modules/Users/router";
import { checkRole } from "./hoc";
import { useMailAmbitionRoutes } from "./modules/MailAmbition/router";
import { PATHS } from "./constants/paths";
import { useManualRoutes } from "./modules/Manual/router";
import { useWidgetsRoutes } from "./modules/Widgets/router";
import { useAppConfigRoutes } from "./modules/AppConfig/router";
import { useAgentsRoutes } from "./modules/Agents/router";
import { useDataRoutes } from "./modules/Data/router";

interface RouterProps {
  isAppLoading: boolean;
}

const Router = ({ isAppLoading }: RouterProps) => {
  const SentryRoutes = Sentry.wrapReactRouterRouting(Routes);

  const isServiceUser = checkRole("service_user");
  const isProjectManager = checkRole("project_manager");
  const isSuperadmin = checkRole("superadmin");

  const dashboardRoutes = useDashboardRoutes();
  const customerRoutes = useCustomerRoutes();
  const usersRoutes = useUsersRoutes();
  const mailAmbitionRoutes = useMailAmbitionRoutes();
  const manualRoutes = useManualRoutes();
  const appConfigRoutes = useAppConfigRoutes();
  const widgetsRoutes = useWidgetsRoutes();
  const agentsRoutes = useAgentsRoutes();
  const dataRoutes = useDataRoutes();

  return (
    <BrowserRouter>
      <SentryRoutes>
        <Route element={<Layout isAppLoading={isAppLoading} />}>
          {dashboardRoutes}
          {customerRoutes}
          {isProjectManager && usersRoutes}
          {isProjectManager && mailAmbitionRoutes}
          {isProjectManager && manualRoutes}
          {isSuperadmin && widgetsRoutes}
          {isSuperadmin && agentsRoutes}
          {isProjectManager && appConfigRoutes}
          {isServiceUser && dataRoutes}
          <Route path="*" element={<Navigate to={PATHS.Dashboard.Path} />} />
        </Route>
      </SentryRoutes>
    </BrowserRouter>
  );
};

export { Router };
